import {ElMessage, ElMessageBox} from 'element-plus';
import {Role} from 'common';

export enum ReportGroup {
    verleden = 'verleden',
    heden    = 'heden',
    toekomst = 'toekomst'
}

export function roleLabel(role: Role): string {
    return role.split('_').map((word: string) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
}

export function renderDateTimeLocal(d: Date): string {
    return d.toLocaleString('nl-NL', {
        dateStyle: 'short',
        timeStyle: 'short',
    });
}

export async function askForTag(title: string) {
    try {
        const {value} = await ElMessageBox.prompt(`Geef een tag:`, title, {
            confirmButtonText: 'OK',
            cancelButtonText : 'Cancel',
            inputPattern     : /^[-A-Za-z0-9_]*$/,
            inputErrorMessage: `Tags bestaan slechts uit letters, cijfers, '-' en '_'`,
            inputPlaceholder : 'download',
        });
        return value ? value : 'download';
    } catch (error) {
        return undefined;
    }
}

export async function downloadFile(response: Response, filename: string) {
    if (!response.ok) {
        ElMessage({
            message: `Failed: ${response.statusText}`,
            type   : 'error',
        });
    } else {
        const blob: Blob  = await response.blob();
        const url: string = URL.createObjectURL(blob);
        const link        = document.createElement('a');
        link.href         = url;
        link.download     = filename;
        link.click();
        URL.revokeObjectURL(url);

        const l: string | null = response.headers.get('content-length');
        const msg: string      = l
            ? `Downloaded ${Math.floor(+l / 1024)} kb`
            : 'Download done';
        ElMessage({
            message: `${msg}`,
            type   : 'success',
        });
    }
}

export async function jsonBodyFromResponse(res: Response): Promise<any> {
    let result = '';
    if (res.body != null) {
        const reader  = res.body.getReader();
        const decoder = new TextDecoder();
        while (true) {
            const {
                done,
                value,
            } = await reader.read();
            if (done) {
                break;
            }
            result += decoder.decode(value);
        }
    }
    return JSON.parse(result);
}

export function localStorageGetJson(name: string): any {
    const item = localStorage.getItem(name);
    if (!item) {
        return undefined;
    }
    try {
        return JSON.parse(item);
    } catch (e) {
        return undefined;
    }
}

export function localStorageSetJson(name: string, o: any) {
    localStorage.setItem(name, JSON.stringify(o));
}

export type SelectGroupInfo = {
    name: string,
    id: string,
}

const DIGIT_SHIFT = 7.5;
const EXTRA_SHIFT = 24;

export function badgeOffset(base: [number, number], extra: boolean, value: number | undefined, valueExtra: number | undefined): [number, number] {
    if (10 <= (value || 0)) {
        base[0] -= DIGIT_SHIFT;
    }
    if (100 <= (value || 0)) {
        base[0] -= DIGIT_SHIFT;
    }
    if (extra) {
        base[0] += -EXTRA_SHIFT;
        base[1] += -1.5;
        if (10 <= (valueExtra || 0)) {
            base[0] -= DIGIT_SHIFT;
        }
        if (100 <= (valueExtra || 0)) {
            base[0] -= DIGIT_SHIFT;
        }
    }
    return base;
}
